module.exports = __webpack_public_path__ + "e782526f869f1bb6fb03902c256351d9.svg";